var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAmexIcon = function SvgAmexIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_10454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.47149C0 2.3923 1.68552 0.706787 3.76471 0.706787H28.2353C30.3145 0.706787 32 2.3923 32 4.47149V19.5303C32 21.6095 30.3145 23.295 28.2353 23.295H3.76471C1.68552 23.295 0 21.6095 0 19.5303V4.47149Z",
    fill: "#1F72CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66049 8.54675L2.6665 15.4484H6.25073L6.69506 14.348H7.71073L8.15506 15.4484H12.1003V14.6085L12.4518 15.4484H14.4926L14.8441 14.5908V15.4484H23.0491L24.0468 14.3766L24.981 15.4484L29.1953 15.4573L26.1918 12.0169L29.1953 8.54675H25.0464L24.0752 9.59878L23.1704 8.54675H14.2445L13.478 10.3281L12.6935 8.54675H9.11679V9.35804L8.7189 8.54675H5.66049ZM6.35412 9.5268H8.10123L10.0871 14.2069V9.5268H12.001L13.5349 12.8824L14.9486 9.5268H16.8529V14.4792H15.6942L15.6847 10.5985L13.9954 14.4792H12.9588L11.26 10.5985V14.4792H8.87623L8.4243 13.3689H5.98273L5.53174 14.4782H4.25452L6.35412 9.5268ZM22.6247 9.5268H17.913V14.4763H22.5518L24.0469 12.8359L25.488 14.4763H26.9944L24.8048 12.0159L26.9944 9.5268H25.5533L24.0658 11.1483L22.6247 9.5268ZM7.20394 10.3647L6.39953 12.3426H8.0074L7.20394 10.3647ZM19.0765 11.4562V10.5522V10.5513H22.0165L23.2993 11.9971L21.9596 13.4509H19.0765V12.4639H21.647V11.4562H19.0765Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.20679,
    width: 31,
    height: 21.5882,
    rx: 3.5,
    stroke: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_10454"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.706787,
    width: 32,
    height: 22.5882,
    rx: 4,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmexIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "amex-icon.a3f04f13d23c840883d0e646597c9ed4.svg";